import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { AssignmentAvailabilityStatus } from '@wilson/interfaces';
import { firstValueFrom } from 'rxjs';
import { TimelineModalFilterService } from '../../services/timeline-modal-filter.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { FilterQualifiedStaffChangedButtonComponent } from '../filter-qualified-staff-changed-button/filter-qualified-staff-changed-button.component';
import { FilterQualifiedWorkingTimeStaffChangedButtonComponent } from '../filter-qualified-working-time-staff-changed-button/filter-qualified-working-time-staff-changed-button.component';

@Component({
  selector: 'wilson-find-activity-staff-popup-quick-filter',
  templateUrl: './find-activity-staff-popup-quick-filter.component.html',
  styleUrls: ['./find-activity-staff-popup-quick-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    NzButtonModule,
    FilterQualifiedStaffChangedButtonComponent,
    FilterQualifiedWorkingTimeStaffChangedButtonComponent,
  ],
})
export class FindActivityStaffPopupQuickFilterComponent {
  private readonly cdRef = inject(ChangeDetectorRef);
  timelineModalFilterService = inject(TimelineModalFilterService);

  AssignmentAvailabilityStatus = AssignmentAvailabilityStatus;

  async staffAvailabilityChanged() {
    const currentAvailabilityFilter = await firstValueFrom(
      this.timelineModalFilterService.staffAvailability$,
    );

    let nextAvailabilityFilter = AssignmentAvailabilityStatus.Available;

    switch (currentAvailabilityFilter) {
      case AssignmentAvailabilityStatus.Available:
        nextAvailabilityFilter = AssignmentAvailabilityStatus.PartlyAvailable;
        break;
      case AssignmentAvailabilityStatus.PartlyAvailable:
        nextAvailabilityFilter = AssignmentAvailabilityStatus.NotAvailable;
        break;
    }

    this.timelineModalFilterService.staffAvailabilityChanged(
      nextAvailabilityFilter,
    );
    this.cdRef.detectChanges();
  }

  async qualifiedStaffChanged() {
    this.timelineModalFilterService.qualifiedStaffChanged(false);
    this.cdRef.detectChanges();
  }

  async qualifiedWorkingTimeStaffChanged() {
    this.timelineModalFilterService.qualifiedWorkingTimeStaffChanged(false);
    this.cdRef.detectChanges();
  }
}
